import { Permission } from '@cims-online/shared'
import { EditRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import {
  PayItemsWorkflow,
  useInternalConnectionsContext,
} from '../../InternalConnectionsContext'
import GroupSelect from '../../../GroupSelect'
import { GroupSelectValue } from '../../../GroupSelect/types'
import {
  useEditProjectToGroupToInternalMutation,
  useEditWorkflowPayItemSummaryConnectionMutation,
} from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleEditNotification } from 'hooks/notificationHandler'
import { useProjectContext } from 'context/ProjectContext'

export function useEdit(): EditRowActionOptions<
  PayItemsWorkflow,
  GroupSelectValue
> {
  const { projectId } = useProjectContext()
  const { refetch, fetching, groups } = useInternalConnectionsContext()
  const [edit] = useEditProjectToGroupToInternalMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      editProjectToInternalConnection: {
        projectToInternalConnection: { internalConnection },
      },
    }) => simpleEditNotification(internalConnection),
  })
  const [editWorkflow] = useEditWorkflowPayItemSummaryConnectionMutation({
    ...DefaultMutationHookOptions,
    onCompleted: () => simpleEditNotification('Workflow'),
  })
  return {
    permission: Permission.EditPayItemConnection,
    modal: {
      type: 'simple',
      recordName: (record) =>
        'internal' in record
          ? record.internal.module.name
          : record.workflow.label,
      initialValues: ({ group }) => ({
        group: group
          ? { label: group.name, value: group.id, tooltip: group.description }
          : undefined,
      }),
      body: (
        <>
          <GroupSelect loading={fetching} options={groups} />
        </>
      ),
      onOk: async (connection, { group }) => {
        if (group?.value === connection.group?.id) return
        const groupId = (group?.value as string) ?? null
        if ('internal' in connection)
          await edit({
            variables: {
              input: {
                internalConnectionId: connection.id,
                projectId,
                groupId,
              },
            },
          })
        else
          await editWorkflow({
            variables: {
              input: { workflowId: connection.workflowId, projectId, groupId },
            },
          })
        refetch()
      },
    },
  }
}
